import { useFormikContext } from 'formik';
import Spacer from '@antimatterhq/ui/components/spacer';
import { Label } from '@antimatterhq/ui/components/label';
import { FormCodeEditor, FormError } from '@/components/form/form';
import { TransformSchemaValues } from '@/zod/schemas/transforms/TransformSchema';
import {
  transformFilterTooltip,
  transformSqlTooltip,
} from '@/strings/StringsTooltips';

export const TransformFilterForm = () => {
  const { values, handleChange, handleBlur } =
    useFormikContext<TransformSchemaValues>();

  return (
    <>
      <Label htmlFor="filter" id="filter-label" info={transformFilterTooltip}>
        Filter (Optional)
      </Label>
      <FormCodeEditor
        name="filter"
        placeholder="Add a SQL expression filter"
        value={values.filter}
        onChange={handleChange}
        onBlur={handleBlur}
        aria-labelledby="filter-label"
      />
      <FormError name="filter" />

      <Spacer size="lg" />

      <Label htmlFor="sql" id="sql-label" info={transformSqlTooltip}>
        SQL
      </Label>
      <FormCodeEditor
        name="sql"
        placeholder="Enter your SQL query here"
        value={values.sql}
        onChange={handleChange}
        language="sql"
        onBlur={handleBlur}
        aria-labelledby="sql-label"
      />
      <FormError name="sql" />
    </>
  );
};
